module.exports = __webpack_public_path__ + "img/Studio.222132f9.jpg";